import type { HelpFile } from '../../types/help'
import { WorkflowTimelineCardTestIds } from '../../../testids/WorkflowTimelineCardTestIds'

export const workflowTimelineCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rule-requests',
  texts: {
    [WorkflowTimelineCardTestIds.workflowTimelineCard]:
      'Lifecycle history of this request — Draft, Submitted, and the terminal Approved/Rejected/Cancelled decision (when present).',
    [WorkflowTimelineCardTestIds.cardTitleWorkflowTimeline]: null,
    [WorkflowTimelineCardTestIds.workflowTimelineCreated]:
      'When the draft request was first created.',
    [WorkflowTimelineCardTestIds.workflowTimelineSubmitted]:
      'When the request entered the approval workflow.',
    [WorkflowTimelineCardTestIds.workflowTimelineApproved]:
      'When the assigned reviewer(s) approved the request.',
    [WorkflowTimelineCardTestIds.workflowTimelineRejected]:
      'When the assigned reviewer rejected the request.',
    [WorkflowTimelineCardTestIds.workflowTimelineCancelled]:
      'When the requester withdrew the request before any decision was made.',
  },
}
